module.exports = __webpack_public_path__ + "static/media/Internationalpic1@2x.7f2d3fc5.png";